<template>
	<div class="user-role">
		<el-row>
			<el-col :span="5" class="colSpan">
				<div style="padding-right: 30px">
					<div class="roleFilter">
						<el-input
							:placeholder="$t('userRole.pRoleFilter')"
							size="small"
							:clearable="true"
							v-model="userFilterText"></el-input>
					</div>
					<el-tree
						:data="roleList"
						ref="userTree"
						accordion
						:expand-on-click-node="true"
						:props="defaultProps"
						:filter-node-method="userFilterNode"
						@node-click="nodeRoleUser">
						<span class="custom-tree-node" slot-scope="{ node, data }">
							<span>{{ data.name }}</span>
						</span>
					</el-tree>
				</div>
			</el-col>
			<el-col :span="19">
				<el-row>
					<el-col :span="4">
						<el-button
							type="danger"
							size="small"
							v-hasPerm="['sys:user:role:clear']"
							:disabled="userIds.length <= 0"
							@click="assignRole"
							>{{ $t("userRole.clearRole") }}</el-button
						>
					</el-col>
					<el-col :span="20">
						<el-form
							:inline="true"
							:model="userRole"
							class="demo-form-inline"
							size="small"
							style="float: right">
							<el-form-item>
								<el-input
									v-model="userRole.userName"
									:placeholder="$t('userRole.userName')"></el-input>
							</el-form-item>
							<el-form-item>
								<el-input
									v-model="userRole.nickName"
									:placeholder="$t('userRole.nickName')"></el-input>
							</el-form-item>
							<el-form-item>
								<el-button
									type="primary"
									icon="el-icon-search"
									@click="userRoleQuery"
									>{{ $t("userRole.query") }}</el-button
								>
								<el-button icon="el-icon-refresh" @click="userRoleReset">{{
									$t("common.reset")
								}}</el-button>
							</el-form-item>
						</el-form>
					</el-col>
				</el-row>
				<el-table
					v-loading="loading"
					:empty-text="$t('common.noData')"
					:element-loading-text="$t('common.loading')"
					:data="userList"
					style="width: 100%"
					max-height="300"
					ref="userTable"
					@select="select"
					@select-all="selectAll">
					<el-table-column type="selection" fixed width="55"></el-table-column>
					<el-table-column
						prop="userName"
						:label="$t('userRole.userName')"
						width="300"
						:show-overflow-tooltip="true"></el-table-column>
					<el-table-column
						prop="nickName"
						:label="$t('userRole.nickName')"
						width="300"
						:show-overflow-tooltip="true"></el-table-column>
					<el-table-column
						prop="roles"
						:label="$t('userRole.roles')"
						:show-overflow-tooltip="true">
						<template slot-scope="scope">
							<template
								v-if="scope.row.roleList && scope.row.roleList.length > 0">
								<span v-for="(item, index) in scope.row.roleList" :key="index">
									{{ item.name }}
								</span>
							</template>
							<template v-else
								><span class="not-role">{{
									$t("userRole.noRole")
								}}</span></template
							>
						</template>
					</el-table-column>
					<el-table-column
						fixed="right"
						:width="$i18n.locale == 'zh_CN' ? 100 : 100"
						align="center"
						:label="$t('common.operate')">
						<template slot-scope="scope">
							<el-button
								size="mini"
								type="warning"
								v-hasPerm="['sys:user:role:insert']"
								@click="editRole(scope.row)"
								>{{ $t("userRole.role") }}</el-button
							>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination
					background
					layout="total,sizes,prev, pager, next,jumper"
					:current-page="userRole.pageIndex"
					:total="totalSize"
					:page-size="userRole.pageSize"
					@size-change="sizeChange"
					@current-change="currentChange"></el-pagination>
			</el-col>
		</el-row>
		<el-dialog
			:modal-append-to-body="true"
			:append-to-body="true"
			:title="$t('userRole.assign')"
			:visible.sync="dialogVisible"
			width="25%"
			@open="openListRole"
			top="9vh"
			:before-close="handleClose">
			<el-select
				v-model="values"
				:no-data-text="$t('common.noData')"
				:no-match-text="$t('common.noData')"
				filterable
				multiple
				clearable
				:placeholder="$t('userRole.pRole')"
				style="width: 100%">
				<el-option
					v-for="item in listRole"
					:key="item.id"
					:label="item.name"
					:value="item.id"></el-option>
			</el-select>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">{{
					$t("common.cancel")
				}}</el-button>
				<el-button type="primary" @click="saveUserRole">{{
					$t("common.definite")
				}}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: "UserRole",
	data() {
		return {
			userFilterText: "",
			active: "",
			loading: false,
			userList: [],
			selection: true,
			userRole: {
				roleId: "",
				userName: "",
				nickName: "",
				pageIndex: 1,
				pageSize: 10,
			},
			isRoleCheck: false,
			totalSize: 0,
			userIds: [],
			roleId: [],
			dialogVisible: false,
			listRole: [],
			values: [],
			uId: "",
			userTypeList: [],
		};
	},
	props: {
		roleList: Array,
		defaultProps: Object,
	},
	watch: {
		userFilterText(val) {
			this.$refs.userTree.filter(val);
		},
	},
	mounted() {
		this.getUserList();
		this.getRoleList();
		this.listUserType();
	},
	methods: {
		listUserType() {
			this.$api.dict("sys_user_type").then(res => {
				this.userTypeList = res.data;
			});
		},

		// 角色筛选
		userFilterNode(value, data) {
			if (!value) return true;
			return data.name.indexOf(value) !== -1;
		},

		editRole(data) {
			this.dialogVisible = true;
			this.uId = data.id;
			// 选项
			this.values = [];
			if (data.roleList && data.roleList.length > 0) {
				data.roleList.forEach(key => {
					this.values.push(key.id);
				});
			}
		},

		handleClose() {
			this.dialogVisible = false;
		},

		openListRole() {},

		// 加载用户
		getUserList() {
			this.loading = true;
			this.userIds = [];
			this.$api
				.request(
					this.$url.AuthorityUserRole.pageUserByRoleId,
					this.$method.get,
					this.userRole
				)
				.then(res => {
					if (res.code === 0) {
						this.userList = res.data.records;
						this.totalSize = Number(res.data.total);
					}
					this.loading = false;
				})
				.catch(() => {
					this.loading = false;
				});
		},

		// 加载角色
		getRoleList() {
			this.$api
				.request(this.$url.AuthorityRole.listByPid, this.$method.get)
				.then(res => {
					if (res.code === 0) {
						this.listRole = res.data;
					}
				});
		},

		// 点击下一页或上一页
		currentChange(pageIndex) {
			this.userRole.pageIndex = pageIndex ? pageIndex : 1;
			this.getUserList();
		},
		sizeChange(pageSize) {
			this.page.pageSize = pageSize;
			this.currentChange();
		},
		// 根据条件查询用户
		userRoleQuery() {
			this.getUserList();
		},

		// 清空筛选条件
		userRoleReset() {
			this.userRole.roleId = "";
			this.userRole.nickName = "";
			this.userRole.userName = "";
			this.getUserList();
		},

		// 更新用户角色信息
		saveUserRole() {
			if (this.uId && this.values.length > 0) {
				let obj = { id: this.uId, roleIds: this.values };
				this.$api
					.request(this.$url.AuthorityUserRole.save, this.$method.post, obj)
					.then(res => {
						if (res.code === 0) {
							this.$message.success(this.$t("userRole.success"));
							this.dialogVisible = false;
							this.getUserList();
						} else {
							this.$message.error(res.msg);
						}
					});
			}
		},

		select(selection) {
			this.setUserId(selection);
		},

		selectAll(selection) {
			this.setUserId(selection);
		},

		// 设置选中用户 id
		setUserId(e) {
			this.userIds = [];
			e.forEach(key => {
				this.userIds.push(key.id);
			});
		},

		// 切换角色分配
		assignRole() {
			if (this.userIds.length > 0) {
				this.$api
					.request(
						this.$url.AuthorityUserRole.clearRole,
						this.$method.post,
						this.userIds
					)
					.then(res => {
						if (res.code === 0) {
							this.$message.success(this.$t("userRole.clear"));
							this.getUserList();
						}
					});
			}
		},
		// 点击角色加载对应用户
		nodeRoleUser(data) {
			if (data.pid !== "0") {
				this.userRole.roleId = data.id;
				this.getUserList();
			}
		},
		userType(row) {
			return this.$cloud.getDictLabel(this.userTypeList, row.userType);
		},
	},
};
</script>

<style scoped lang="scss">
.user-role .not-role {
	color: #e6a23c;
}
</style>
